let currentPage = '';
let currentComponent = '';

export const setRequestPage = (page: string) => {
  currentPage = page;
};

export const setRequestComponent = (component: string) => {
  currentComponent = component;
};

export const getRequestPage = () => currentPage;

export const getRequestComponent = () => currentComponent;
